
  import { Component, OnInit, Output, EventEmitter, Input, ViewChild, TemplateRef } from '@angular/core';
  import { HttpClient } from '@angular/common/http';
  import { NbDialogService } from '@nebular/theme';
  import { CookieService } from 'ngx-cookie-service';
  
  import * as _ from 'lodash';

@Component({
  selector: 'app-select-billmachine-moudle',
  templateUrl: './select-billmachine-moudle.component.html',
  styleUrls: ['./select-billmachine-moudle.component.scss']
})
export class SelectBillmachineMoudleComponent implements OnInit {

  USR_AccountInfo_ID: string;
  ORG_Company_ID: number;
  ORG_Store_ID: number
  @Output() emitClose = new EventEmitter();
  @Output() emitList = new EventEmitter();
  @Input() orgData: Array<any>;  //已選資料_來源
  @Input() info: {
    PrintMachine_Type:number[],
    IsLoding:boolean
    ORG_Store_ID: number,
  };

  //-----------------------談窗----------------------------

  modalRef = null;  //談窗鉤子
  PdModalRef = null;  //談窗鉤子

  @ViewChild('Modal') Modal: TemplateRef<any>
  @ViewChild('PdModal') PdModal: TemplateRef<any>

  //--------------------------------------------------------

  //資料清單
  mainDataList: Array<BillMachineDTO>; //選單資料
  showList: Array<any>;     //群組顯示資料 
  showListPd: Array<any>;   //商品顯示資料 
  query = {  //查詢選項
    searchKey: ""
  }
  status: { //當前狀態
    isSelectAll: boolean //是否已全選
    showType: number // 顯示有選過的
  }

  //查詢的門市
  storeSelectList: selectData[];
  selectORG_Store_ID: number;


  constructor(
    private dialogService: NbDialogService,
    private http: HttpClient,
    private cookieService: CookieService,
  ) {
      this.USR_AccountInfo_ID = this.cookieService.get('USR_AccountInfo_ID') ? 
      "USR_AccountInfo_ID_"+this.cookieService.get('USR_AccountInfo_ID') :
        this.cookieService.get('USR_POSEmployeeInfo_ID') ?  
          "USR_POSEmployeeInfo_ID"+this.cookieService.get('USR_POSEmployeeInfo_ID') : null;
  
    let cookie_sid = this.cookieService.get('ORG_Store_ID')
    this.ORG_Store_ID = (cookie_sid && cookie_sid != '') ? parseInt(cookie_sid) : null
    this.ORG_Company_ID = parseInt(this.cookieService.get('ORG_Company_ID'));
  }


  ngOnInit(): void {
  }


  ngAfterViewInit() {
    this.onOpen(this.info)
  }


  //取得門市清單 API
  getStoreList(fun) {//取得門市清單 USP_YOPOSWebGetStoreList
    this.http.post<any>('api/ORGStore/StoreList', {
      ORG_Company_ID: this.ORG_Company_ID,
      ORG_Store_ID: this.ORG_Store_ID,
    }).subscribe({

      next: data => {

        this.storeSelectList = [];

        if(this.ORG_Store_ID ){
          //門市共用下拉選單
          let Item :any= {};
          Item.value = this.ORG_Store_ID;
          Item.content = data.LIST.find(x=>x.ORG_Store_ID == this.ORG_Store_ID ).StoreName;
          this.storeSelectList.push(Item);
        }
        else
        {
          data.LIST.forEach(element => {
            //門市共用下拉選單
            var selectItem = new selectData();
            selectItem.value = element.ORG_Store_ID;
            selectItem.content = element.StoreName;
            this.storeSelectList.push(selectItem);
          });
        }
        
        // 預設點第一個
        if (this.storeSelectList.length > 0) {
          this.selectORG_Store_ID = this.storeSelectList[0].value
        }

        if(fun)
          fun()
      },
      error: error => {
        console.error('There was an error!', error);
      }
    });
  }


  onOpen(info) {
    if (info)
      this.info = info

    this.getStoreList(()=>{
      //api抓資料
      this.getPdGroupList();
    })

    //開啟談窗
    this.modalRef = this.dialogService.open(this.Modal, {})
    this.modalRef.onClose.subscribe(result => {
      this.emitClose.emit(true);
    });
  }

  //---------------------------------------------------

  //查詢
  onQuery() {
    this.getPdGroupList();
  }


  //處存商品群組
  onSavePdG() {
    let useData = [];
    
    // 篩選出被選取的資料 (IsOK_Group 為 true 的項目)
    if(this.mainDataList) {
        useData = this.mainDataList
            .filter(item => item.IsOK_Group)
            .map(item => ({
                SYS_PrintMachine_ID: item.SYS_PrintMachine_ID,
                ORG_Store_ID: this.selectORG_Store_ID
            }));
    }

    this.emitList.emit(useData);
    this.modalRef.close();
}


  //---------------------------------------------------


  //取得門市出單機
  getPdGroupList() {
    this.info.IsLoding= true

    this.http.get<{ LIST: BillMachineDTO[] }>('api/BillMachine/GetBillMachineList?' + 
      `ORG_Store_ID=${this.selectORG_Store_ID}` +
      `&IsDelete=${false}` +
      `&Page=1&PerPage=2147483647`
    ).subscribe({
      next: data => {
        this.info.IsLoding = false
  
        data.LIST.forEach(x => {
          x.GroupNo = x.SYS_PrintMachine_ID;
          x.IsOK_Group = false;
        });
        
        const filteredList = data.LIST.filter((item: BillMachineDTO) =>
          this.info.PrintMachine_Type.includes(item.PrintMachine_Type)
        );

        this.mainDataList = filteredList
        //合併到原始資料
        this.orgData = _.cloneDeep(this.mainDataList)
      },
      error: error => {
        console.error('There was an error!', error);
        this.info.IsLoding = false
      }
    });
  }
}

class selectData {
  value: number;//
  content: string;//
  info:string
}

interface BillMachineDTO {
  SYS_PrintMachine_ID: string;
  PrintMachine_Type: number;
  PrintMachine_Brand: number;
  PrintMachine_Name: string;
  PrintMachine_IP: string;
  PrintMachine_Port: string;
  PaperSize: number;
  AlignType: number;
  POS_Machine_IDs: string;
  KIOSK_Machine_IDs: string;
  GroupNo?: string;
  IsOK_Group?: boolean;
}